export const STATUS_FLOW = ["pending", "preparing", "ready", "delivering", "delivered"];

export function getOrderTypeFlags(order) {
  const isDelivery = !!order.delivery_address;
  const isPickup = order.source === "pickup" || (!order.delivery_address && !order.table_number);
  const isTable = !!order.table_number;
  return { isDelivery, isPickup, isTable };
}

export function getNextStatus(order, isPickup, isTable) {
  const currentIdx = STATUS_FLOW.indexOf(order.status);
  const rawNextStatus = currentIdx >= 0 && currentIdx < STATUS_FLOW.length - 1 ? STATUS_FLOW[currentIdx + 1] : null;
  return (rawNextStatus === "delivering" && (isPickup || isTable)) ? "delivered" : rawNextStatus;
}
